/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// List of 6 qty items by Vairable ID (not product ID)
window.minSixVariantIds = ["45405413933340", "50782267703580"];

// Webtoon custom remove free shipping counter
document.addEventListener('DOMContentLoaded', function () {
    const cartContainer = document.getElementById('CartContainer');

    if (!cartContainer) return;

    function updateFreeShippingMessage() {
        const freeShippingMessage = document.querySelector('.qualify-free-shipping');

        if (!freeShippingMessage) return;

        const hasWebtoonBundle = cartContainer.querySelector(
            'a[href*="/products/webtoon-ramyun-bundle"]'
        );

        freeShippingMessage.hidden = Boolean(hasWebtoonBundle);
    }

    const observer = new MutationObserver(updateFreeShippingMessage);

    observer.observe(cartContainer, {
        childList: true,
        subtree: true
    });

    updateFreeShippingMessage();
});